/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExerciseAnswer
 */
export interface ExerciseAnswer {
    /**
     * 
     * @type {string}
     * @memberof ExerciseAnswer
     */
    exerciseName?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseAnswer
     */
    thumbnailUrl?: string;
}

export function ExerciseAnswerFromJSON(json: any): ExerciseAnswer {
    return ExerciseAnswerFromJSONTyped(json, false);
}

export function ExerciseAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exerciseName': !exists(json, 'exercise-name') ? undefined : json['exercise-name'],
        'thumbnailUrl': !exists(json, 'thumbnail-url') ? undefined : json['thumbnail-url'],
    };
}

export function ExerciseAnswerToJSON(value?: ExerciseAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exercise-name': value.exerciseName,
        'thumbnail-url': value.thumbnailUrl,
    };
}


